import { render, staticRenderFns } from "./SanneStep.vue?vue&type=template&id=35f6ed62&scoped=true&"
import script from "./SanneStep.vue?vue&type=script&lang=js&"
export * from "./SanneStep.vue?vue&type=script&lang=js&"
import style0 from "./SanneStep.vue?vue&type=style&index=0&id=35f6ed62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f6ed62",
  null
  
)

export default component.exports